export const isTerminalStatus = (status) => status === 'completed' || status === 'failed';

// A run is done once every attempted profile has a result, even if the backend's terminal
// `status` tick was delayed or dropped (socket emits are best-effort). Deriving "done" from
// the counts lets the card surface the result instead of stalling on a missed `completed`.
export const isRunDone = (run) =>
  isTerminalStatus(run?.status) || (run?.total > 0 && run?.completed >= run.total);

// A finished run reads as 100%; a running run is completed/total. Guards the
// zero-total window before the worker's first tick so the bar starts empty.
export const runProgress = (run) => {
  if (isRunDone(run)) return 100;
  if (!run?.total) return 0;
  return Math.min(Math.round((run.completed / run.total) * 100), 100);
};

export const runStatusLabel = (run) => {
  if (run?.status === 'failed') return 'Failed';
  if (isRunDone(run)) return `${run.total || run.completed || 0} checked`;
  if (run?.status === 'queued') return 'Preparing…';
  return `${run?.completed || 0} of ${run?.total || 0} checked`;
};
